module.exports = require('./ContentServerLinkView');
